module.exports = require('./ContentServerLinkView');
